module.exports = "/_next/static/images/logo_only-a633431a2761d8e77ad5b91cc9d351d7.png";